import { ReactElement, ReactNode, useCallback, useMemo } from 'react';
import { TextField, ListItemText } from '@mui/material';
import { chain } from 'lodash';

import { SelectWithScopeFieldProps } from './types';
import SelectWithScopeFieldMenuItem from './MenuItem';

const SelectWithScopeField = ({
  options,
  ...props
}: SelectWithScopeFieldProps): ReactElement => {
  const renderValue = useCallback(
    (selectedValue: unknown): ReactNode => {
      const currentValue = chain(options)
        .find({ value: selectedValue as string | number })
        .get('label', '')
        .value();

      return currentValue;
    },
    [options],
  );

  const nameField = useMemo(
    () => props.name ?? props.id,
    [props.name, props.id],
  );

  return (
    <TextField
      {...props}
      select
      SelectProps={{
        renderValue,
        MenuProps: {
          PaperProps: {
            style: {
              width: 'min-content',
            },
          },
        },
      }}
    >
      {options.map((option) => (
        <SelectWithScopeFieldMenuItem
          key={`${nameField}-${option.value}`}
          value={option.value}
          sx={{ whiteSpace: 'pre-wrap' }}
          validSubscriptionFeature={option.validSubscriptionFeature}
        >
          <ListItemText
            primary={option.label}
            secondary={option.scopeDescription}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </SelectWithScopeFieldMenuItem>
      ))}
    </TextField>
  );
};

export default SelectWithScopeField;
